export const READONLY_CHANGE_EVENT = 'slab-readonly-change';

export const LINK_TYPE_ATTRIBUTE = 'data-slab-linktype';
export const LINK_TYPES = {
  embed: 'embed',
  card: 'card',
  text: 'text',
  mention: 'mention',
  iframe: 'iframe',
};

export const MENTION_TEXT_CLIPBOARD_ATTRIBUTE = 'data-slab-mention-text';

export const ENDING_PUNCTUATIONS = new Set([
  '.',
  '?',
  '!',
  ',',
  ':',
  ';',
  ')',
  ']',
]);

export const BLOT_VALUE_ATTRIBUTE = 'data-blot-value';
